<dx-popup [showTitle]="true" title="Articoli: {{articolo.descrizione}}" [dragEnabled]="false" selectionMode="none" [hideOnOutsideClick]="false"
    [showCloseButton]="true" container=".dx-viewport" visible="true" (onHiding)="onEsciClick()" height="80vh">
    <div class="row">        
        <div class="col-lg-4 col-md-6 col-sm-8 col-12 offset-lg-8 offset-md-6 offset-sm-4">
            <dx-button stylingMode="contained" text="CONFERMA" icon="save" type="success" (onClick)="onSalvaClick()" style="width: 150px; margin-right: 10px;">
            </dx-button>       
            <dx-button stylingMode="contained" text="ESCI" icon="close" type="danger" (onClick)="onEsciClick()" style="width: 100px;">
            </dx-button>      
        </div>         
    </div>  
    <dx-data-grid #dataGridArticoliMatricola
        [dataSource]="dataSource"
        [showBorders]="true"
        [showRowLines]="true"
        [showColumnLines]="true"
        [columnAutoWidth]="true"
        (onRowUpdating)="onRowUpdating($event)">
        
        <dxo-paging [pageSize]="10"></dxo-paging>
        <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
        <dxo-filter-row [visible]="true"></dxo-filter-row>

        <dxo-editing
            mode="row"
            [allowAdding]="false"
            [allowUpdating]="true"
            [allowDeleting] ="true"
            [useIcons]="true">
            <dxo-texts confirmDeleteMessage="Sei sicuro di voler eliminare il dettaglio?"></dxo-texts>  
        </dxo-editing>

    <dxi-column
      dataField="id"
      [visible]="false"
      [allowEditing]="false"
      caption="">
    </dxi-column>
    <dxi-column
      dataField="idArticolo"
      [visible]="false"
      [allowEditing]="false"
      caption="">
    </dxi-column>

    <dxi-column
      dataField="matricola"
      caption="Matricola">
    </dxi-column>

    <dxi-column
      dataField="dismesso"
      caption="Dismesso"
      [allowEditing]="false"
      dataType="boolean">
    </dxi-column>
    @for (prop of listPropsArtMatricola; track prop) {
      <dxi-column
        dataField="props.{{prop.nome}}"
        caption="{{prop.nome}}"
        [dataType]="getDataType(prop.tipo)"
        [format]="getDataFormat(prop.tipo)">
        @if (prop.tipo == TIPO_PROPRIETA_ARTICOLO_SELMULTI) {
          <dxo-lookup
            [dataSource]="prop.selMultiplaDati">
          </dxo-lookup>
        }
      </dxi-column>
    }
  </dx-data-grid>
</dx-popup>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)"
  [(visible)]="loadPanelVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false">
</dx-load-panel>